// El nombre local no puede ser `OmniNavListener`: el modulo tambien exporta con ese nombre la
// clase sin conectar (la que se prueba), y entonces el import por defecto la tapa.
import ConnectedOmniNavListener from './OmniNavListener';

export default ConnectedOmniNavListener;
